import React from 'react';
import { Popover, Table } from 'react-bootstrap';
import RmsPopover from '../common/popover/RmsPopover';
import Tracker from '../tracking/tracker';
import { InternalApiMonitoringAlert, InternalApiScoreResult } from '../api-internal';

interface AlertDetailsPopoverProps {
  alert: InternalApiMonitoringAlert;
  withReason?: boolean;
}

const AlertDetailsPopover = ({ alert, withReason }: AlertDetailsPopoverProps) => {
  const results = alert.score;

  const alertDetailsPopover = (scoreResults: InternalApiScoreResult[]) => {
    return (
      <Popover id='alert-details-popover'>
        <Popover.Header as='h3'>Alert details</Popover.Header>
        <Popover.Body>
          <Table striped size='sm' className='card-table'>
            <thead>
              <tr>
                <th>Details</th>
                <th>Scenario name</th>
              </tr>
            </thead>

            <tbody>
              {scoreResults.map((result, index) => {
                return (
                  <tr key={index}>
                    <td className='alert-details' data-testid='alert-details'>
                      {result.details}
                    </td>
                    <td className='text-secondary-details alert-details'>{result.reason}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Popover.Body>
      </Popover>
    );
  };

  if (results.length > 1) {
    return (
      <RmsPopover overlay={alertDetailsPopover(results)} placement='bottom'>
        <span>
          <span className='hover-link' data-testid='hover-link' style={{ wordBreak: 'break-word' }}>
            {results[0].details} • {results.length - 1} more
          </span>
          {withReason && <p className='text-secondary-details m-0 mt-2'>{results[0].reason}</p>}
        </span>
      </RmsPopover>
    );
  } else if (results.length === 1) {
    return (
      <span>
        <span style={{ wordBreak: 'break-word' }}>{results[0].details}</span>
        {withReason && <p className='text-secondary-details m-0 mt-2'>{results[0].reason}</p>}
      </span>
    );
  } else {
    Tracker.error('Empty score results for alert #' + alert.id);
    return <span></span>;
  }
};

export default AlertDetailsPopover;
